import { COLORS } from '@/theme';
import { LayoutSidebar } from '@/ui';
import styled from 'styled-components';

export const StyledSidebar = styled(LayoutSidebar)`
  width: 18rem;
  padding: 2rem 0;
  background-color: inherit !important;
  overflow-y: auto;
  height: 100vh;
  position: fixed !important;
  left: 0;
  top: 0;
  bottom: 0;
  z-index: 99;
  border-right: 1px solid ${COLORS.GREY};
  z-index: 1;

  .ant-layout-sider-children {
    display: flex;
    flex-direction: column;
  }

  @media print {
    display: none !important;
  }
`;
